import { cn } from "@/lib/utils";

interface Option {
  value: string;
  label: string;
  preview?: string;
}

interface MemojiOptionGridProps {
  title: string;
  options: Option[];
  selectedValue?: string;
  onSelect: (value: string) => void;
  className?: string;
}

export const MemojiOptionGrid = ({ 
  title, 
  options, 
  selectedValue, 
  onSelect,
  className 
}: MemojiOptionGridProps) => {
  return (
    <div className={cn("space-y-4", className)}>
      <h3 className="font-semibold text-lg">{title}</h3>
      <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-3">
        {options.map((option) => (
          <button
            key={option.value}
            onClick={() => onSelect(option.value)}
            className={cn(
              "relative p-4 rounded-2xl border-2 transition-all duration-300 hover:scale-110",
              "flex flex-col items-center justify-center min-h-[70px] group",
              "bg-gradient-to-br from-background to-muted/20",
              selectedValue === option.value
                ? "border-primary bg-primary/10 shadow-lg shadow-primary/20 scale-105"
                : "border-muted/30 hover:border-primary/50 hover:shadow-md"
            )}
          >
            {option.preview ? (
              <div className="text-3xl mb-2 transition-transform group-hover:scale-110">
                {option.preview}
              </div>
            ) : (
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-primary/20 to-primary/40 mb-2" />
            )}
            <span className={cn(
              "text-xs font-medium text-center leading-tight transition-colors",
              selectedValue === option.value ? "text-primary" : "text-muted-foreground"
            )}>
              {option.label}
            </span>
            
            {/* Selected indicator */}
            {selectedValue === option.value && (
              <div className="absolute -top-1 -right-1 w-6 h-6 bg-primary rounded-full flex items-center justify-center">
                <div className="w-2 h-2 bg-primary-foreground rounded-full" />
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};